// routes/_authenticated/fundos/$cnpj/documentos.tsx — entry point for
// `/fundos/:cnpj/documentos`. Lifted out of the detail page's
// "Demonstrações e auditoria" tab so the AI-summary workflow has its
// own URL.
//
// ponytail: same CNPJ normalisation as the parent route. A pasted URL
// can carry a masked CNPJ; the fund detail page already does this so
// the child route follows.

import { toDigitsCnpj } from "@shared/utils/cnpj";
import { createFileRoute } from "@tanstack/react-router";

import { FundoDocumentosPage } from "@/features/fundos/documentos";

export const Route = createFileRoute("/_authenticated/fundos/$cnpj/documentos")({
  component: () => {
    const { cnpj } = Route.useParams();
    return <FundoDocumentosPage cnpj={toDigitsCnpj(cnpj) ?? cnpj} />;
  },
});
